export const countryFilterOptions = {
  af: true,
  al: true,
  am: true,
  ao: true,
  ar: true,
  at: true,
  au: true,
  az: true,
  bd: true,
  be: true,
  bg: true,
  bh: true,
  bi: true,
  bj: true,
  bm: true,
  bn: true,
  bo: true,
  br: true,
  bs: true,
  bt: true,
  bw: true,
  bz: true,
  ca: true,
  cd: true,
  ch: true,
  ci: true,
  cm: true,
  cn: true,
  co: true,
  cr: true,
  cu: true,
  cw: true,
  cz: true,
  de: true,
  dk: true,
  dm: true,
  do: true,
  dz: true,
  ec: true,
  ee: true,
  eg: true,
  es: true,
  et: true,
  fi: true,
  fj: true,
  fm: true,
  fr: true,
  ga: true,
  gb: true,
  ge: true,
  gh: true,
  gn: true,
  gq: true,
  gr: true,
  gt: true,
  gw: true,
  gy: true,
  hk: true,
  hn: true,
  ht: true,
  hu: true,
  id: true,
  ie: true,
  il: true,
  im: true,
  in: true,
  iq: true,
  ir: true,
  it: true,
  je: true,
  jm: true,
  jo: true,
  jp: true,
  ke: true,
  kg: true,
  kh: true,
  ki: true,
  kr: true,
  kw: true,
  kz: true,
  la: true,
  lb: true,
  lc: true,
  lk: true,
  lr: true,
  lt: true,
  lu: true,
  lv: true,
  ly: true,
  ma: true,
  md: true,
  mg: true,
  mk: true,
  ml: true,
  mm: true,
  mn: true,
  mr: true,
  mu: true,
  mv: true,
  mw: true,
  mx: true,
  my: true,
  mz: true,
  na: true,
  ne: true,
  ng: true,
  nl: true,
  no: true,
  np: true,
  nz: true,
  om: true,
  pe: true,
  pg: true,
  ph: true,
  pk: true,
  pl: true,
  pr: true,
  ps: true,
  pt: true,
  py: true,
  qa: true,
  ro: true,
  rs: true,
  ru: true,
  rw: true,
  sa: true,
  sb: true,
  sc: true,
  sd: true,
  se: true,
  sg: true,
  si: true,
  sk: true,
  sl: true,
  sn: true,
  so: true,
  sr: true,
  ss: true,
  sv: true,
  sx: true,
  sy: true,
  th: true,
  tj: true,
  tl: true,
  tm: true,
  tn: true,
  tr: true,
  tt: true,
  tw: true,
  tz: true,
  ua: true,
  ug: true,
  ae: true,
  us: true,
  uy: true,
  uz: true,
  ve: true,
  vn: true,
  za: true,
  zm: true,
  zw: true
};

export const countriesMapper = {
  af: "Afghanistan",
  al: "Albania",
  dz: "Algeria",
  as: "American Samoa",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarctica",
  ag: "Antigua and Barbuda",
  ar: "Argentina",
  am: "Armenia",
  aw: "Aruba",
  au: "Australia",
  at: "Austria",
  az: "Azerbaijan",
  bs: "Bahamas",
  bh: "Bahrain",
  bd: "Bangladesh",
  bb: "Barbados",
  by: "Belarus",
  be: "Belgium",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhutan",
  bo: "Bolivia",
  ba: "Bosnia and Herzegovina",
  bw: "Botswana",
  br: "Brazil",
  io: "British Indian Ocean Territory",
  vg: "British Virgin Islands",
  bn: "Brunei",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Cambodia",
  cm: "Cameroon",
  ca: "Canada",
  cv: "Cape Verde",
  ky: "Cayman Islands",
  cf: "Central African Republic",
  td: "Chad",
  cl: "Chile",
  cn: "China",
  cx: "Christmas Island",
  cc: "Cocos Islands",
  co: "Colombia",
  km: "Comoros",
  ck: "Cook Islands",
  cr: "Costa Rica",
  hr: "Croatia",
  cu: "Cuba",
  cw: "Curacao",
  cy: "Cyprus",
  cz: "Czech Republic",
  cd: "Democratic Republic of the Congo",
  dk: "Denmark",
  dj: "Djibouti",
  dm: "Dominica",
  do: "Dominican Republic",
  tl: "East Timor",
  ec: "Ecuador",
  eg: "Egypt",
  sv: "El Salvador",
  gq: "Equatorial Guinea",
  er: "Eritrea",
  ee: "Estonia",
  et: "Ethiopia",
  fk: "Falkland Islands",
  fo: "Faroe Islands",
  fj: "Fiji",
  fi: "Finland",
  fr: "France",
  pf: "French Polynesia",
  ga: "Gabon",
  gm: "Gambia",
  ge: "Georgia",
  de: "Germany",
  gh: "Ghana",
  gi: "Gibraltar",
  gr: "Greece",
  gl: "Greenland",
  gd: "Grenada",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guinea",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  ht: "Haiti",
  hn: "Honduras",
  hk: "Hong Kong",
  hu: "Hungary",
  is: "Iceland",
  in: "India",
  id: "Indonesia",
  ir: "Iran",
  iq: "Iraq",
  ie: "Ireland",
  im: "Isle of Man",
  il: "Israel",
  it: "Italy",
  ci: "Ivory Coast",
  jm: "Jamaica",
  jp: "Japan",
  je: "Jersey",
  jo: "Jordan",
  kz: "Kazakhstan",
  ke: "Kenya",
  ki: "Kiribati",
  xk: "Kosovo",
  kw: "Kuwait",
  kg: "Kyrgyzstan",
  la: "Laos",
  lv: "Latvia",
  lb: "Lebanon",
  ls: "Lesotho",
  lr: "Liberia",
  ly: "Libya",
  li: "Liechtenstein",
  lt: "Lithuania",
  lu: "Luxembourg",
  mo: "Macau",
  mk: "Macedonia",
  mg: "Madagascar",
  mw: "Malawi",
  my: "Malaysia",
  mv: "Maldives",
  ml: "Mali",
  mt: "Malta",
  mh: "Marshall Islands",
  mr: "Mauritania",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Mexico",
  fm: "Micronesia",
  md: "Moldova",
  mc: "Monaco",
  mn: "Mongolia",
  me: "Montenegro",
  ms: "Montserrat",
  ma: "Morocco",
  mz: "Mozambique",
  mm: "Myanmar",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  nl: "Netherlands",
  an: "Netherlands Antilles",
  nc: "New Caledonia",
  nz: "New Zealand",
  ni: "Nicaragua",
  ne: "Niger",
  ng: "Nigeria",
  nu: "Niue",
  kp: "North Korea",
  mp: "Northern Mariana Islands",
  no: "Norway",
  om: "Oman",
  pk: "Pakistan",
  pw: "Palau",
  ps: "Palestine",
  pa: "Panama",
  pg: "Papua New Guinea",
  py: "Paraguay",
  pe: "Peru",
  ph: "Philippines",
  pn: "Pitcairn",
  pl: "Poland",
  pt: "Portugal",
  pr: "Puerto Rico",
  qa: "Qatar",
  cg: "Republic of the Congo",
  re: "Reunion",
  ro: "Romania",
  ru: "Russia",
  rw: "Rwanda",
  bl: "Saint Barthelemy",
  sh: "Saint Helena",
  kn: "Saint Kitts and Nevis",
  lc: "Saint Lucia",
  mf: "Saint Martin",
  pm: "Saint Pierre and Miquelon",
  vc: "Saint Vincent and the Grenadines",
  ws: "Samoa",
  sm: "San Marino",
  st: "Sao Tome and Principe",
  sa: "Saudi Arabia",
  sn: "Senegal",
  rs: "Serbia",
  sc: "Seychelles",
  sl: "Sierra Leone",
  sg: "Singapore",
  sx: "Sint Maarten",
  sk: "Slovakia",
  si: "Slovenia",
  sb: "Solomon Islands",
  so: "Somalia",
  za: "South Africa",
  kr: "South Korea",
  ss: "South Sudan",
  es: "Spain",
  lk: "Sri Lanka",
  sd: "Sudan",
  sr: "Suriname",
  sj: "Svalbard and Jan Mayen",
  sz: "Swaziland",
  se: "Sweden",
  ch: "Switzerland",
  sy: "Syria",
  tw: "Taiwan",
  tj: "Tajikistan",
  tz: "Tanzania",
  th: "Thailand",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad and Tobago",
  tn: "Tunisia",
  tr: "Turkey",
  tm: "Turkmenistan",
  tc: "Turks and Caicos Islands",
  tv: "Tuvalu",
  vi: "U.S. Virgin Islands",
  ug: "Uganda",
  ua: "Ukraine",
  ae: "United Arab Emirates",
  gb: "United Kingdom",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  vu: "Vanuatu",
  va: "Vatican",
  ve: "Venezuela",
  vn: "Vietnam",
  wf: "Wallis and Futuna",
  eh: "Western Sahara",
  ye: "Yemen",
  zm: "Zambia",
  zw: "Zimbabwe",
};
